/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Organization users list component
  Date: Sept 2020
**/

import React, { useEffect, useState } from 'react';
import {
  makeStyles,
  Grid,
  Tooltip,
  IconButton,
  Typography,
  Button,
  FormControl,
  TextField,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  Radio,
} from '@material-ui/core';
import moment from 'moment';
import EditIcon from '@material-ui/icons/Edit';
import AddBoxIcon from '@material-ui/icons/AddBox';
// import { useStoreState, useStoreActions } from 'easy-peasy';

import {
  globalPageTypeEntity,
  // currentUserEntity
} from '../../constants/applicationConstants';
import EnhancedTable from '../enhancedTable/enhancedTable';
import { PopupModal } from '../../submodule';
import { Autocomplete } from '@material-ui/lab';
import { useStoreActions } from 'easy-peasy';

/** STYLES HERE **/
const useStyles = makeStyles(() => ({
  bWhite: {
    backgroundColor: '#fff',
  },
}));
/** ASSOCIATION LIST COMPONENT * */
const OrgsProducts = ({
  organizationData,
  products,
  availableProduct,
  reloadOrg,
}) => {
  const classes = useStyles();

  const [skipPageReset] = useState(false);
  const [productCombination, setProductCombination] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [type, setType] = useState(null);
  const [orgAction, commonAction] = useStoreActions((actions) => [
    actions.organization,
    actions.common,
  ]);
  useEffect(() => {
    const assignedProductTime = products.map((item) => item.title);
    if (
      products.filter(
        (item) => item.title == 'Checkpoint' || item.title == 'Policy',
      ).length > 0
    ) {
      setProductCombination(
        availableProduct.filter(
          (item) => !assignedProductTime.includes(item.title),
        ),
      );
    } else {
      const combineID = availableProduct
        .filter((item) => item.title == 'Checkpoint' || item.title == 'Policy')
        .map((item) => ({ PK: item.PK, title: item.title }));
      setProductCombination([
        ...availableProduct,
        {
          title: 'Checkpoint + Limited Policy Management',
          id: combineID,
          type: 'FE',
          addons: [],
        },
      ]);
    }
  }, [availableProduct]);
  // Columns for Table
  const columns = [
    {
      Header: 'Product Name',
      Cell: ({ row }) => {
        if(row.original.title == "Policy") return <Typography>Policy Management</Typography>
        return <Typography>{row.original.title}</Typography>;
      },
    },
    {
      Header: 'Assigned On',
      Cell: (data) => {
        return (
          <Typography>
            {moment(data.effectivedate).format('DD-MMM-YYYY')}
          </Typography>
        );
      },
    },
    {
      id: 'addon',
      Header: 'Add-On(s) Subscribed',
      Cell: ({ row }) => {
        const currentProd = organizationData.app_products.find(
          (item) => item.title == row.original.title,
        );
        return row?.original?.addons?.length > 0
          ? row?.original?.addons?.map((addon) => (
              <Typography key={addon}>
                {currentProd.addons[1].options[addon].text}
              </Typography>
            ))
          : null;
      },
    },
    {
      Header: ' ',
      Cell: ({ row }) => (
        <Grid>
          <div style={{ display: 'flex' }}>
            <Tooltip title="Edit Product" disabled={row.original.addons.includes('full') || row.original.code == "AUTO"}>
              <IconButton
                color="primary"
                aria-label="Edit Product"
                onClick={() =>
                  userAddEditHandler(
                    event,
                    globalPageTypeEntity.edit,
                    row.original,
                  )
                }
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          </div>
        </Grid>
      ),
    },
  ];

  const userAddEditHandler = (e, op = '', row = '') => {
    setOpen(true);
    setType(op);
    if (op == globalPageTypeEntity.edit) {
      const filterProduct = organizationData.app_products
        .filter((item) => row.title === item.title)
        .pop();
      setSelectedProduct(filterProduct);
      setSelectedAddons(row.addons);
    }
  };
  const createProduct = (payload) => {
    orgAction
      .addProdcutToOrgs(payload)
      .then((res) => {
        reloadOrg();
        setSelectedAddons([]);
        setSelectedProduct(null);
        setOpen(false);
      })
      .catch((err) => {
        const errorMessage = err?.response?.data?.error
          .map((error) => Object.values(error))
          .join('<br/>');
        commonAction.setSubmitSnackbar({
          status: true,
          error: true,
          messages: errorMessage,
        });
      });
  };
  const updateProdduct = async () => {
    if (type == globalPageTypeEntity.add) {
      if (selectedProduct.type == 'FE') {
        selectedProduct.id.forEach((product) => {
          createProduct({
            product_id: product.PK,
            PK: organizationData.PK,
            effectivedate: organizationData.effectivedate,
            addons: product.title == 'Policy' ? ['limited'] : [],
          });
        });
      } else {
        createProduct({
          product_id: selectedProduct.PK,
          PK: organizationData.PK,
          effectivedate: organizationData.effectivedate,
          addons: selectedAddons,
        });
      }
    } else {
      const filterProduct = organizationData.products
        .filter((item) => item.title == selectedProduct.title)
        .pop();
      orgAction
        .updateProdcutToOrgs({
          current_status: filterProduct.current_status,
          PK: organizationData.PK,
          SK: selectedProduct.PK,
          effectivedate: organizationData.effectivedate,
          addons: selectedAddons,
        })
        .then((res) => {
          reloadOrg();
          setSelectedAddons([]);
          setSelectedProduct(null);
          setOpen(false);
        })
        .catch((err) => {
          const errorMessage = err?.data?.error
            .map((error) => Object.values(error))
            .join('<br/>');
          commonAction.setSubmitSnackbar({
            status: true,
            error: true,
            messages: errorMessage,
          });
        });
    }
  };

  return (
    <>
      <Grid item md={12} className={`${classes.bWhite}`}>
        <Grid item md={12} className={`${classes.authBox}`}>
          <EnhancedTable
            columns={columns}
            data={products}
            skipPageReset={skipPageReset}
            toolbar={{
              show: true,
              title: 'Products',
              enableSearch: false,
              actionButtonGroup: (selected) => {
                return (
                  <div style={{ display: 'flex' }}>
                    {productCombination.length > 0 && (
                      <Tooltip title="Add Product">
                        <IconButton
                          color="primary"
                          aria-label="Add"
                          onClick={() =>
                            userAddEditHandler(event, globalPageTypeEntity.add)
                          }
                        >
                          <AddBoxIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                );
              },
            }}
          />
        </Grid>
      </Grid>
      <PopupModal open={open} maxWidth="sm">
        <Grid
          container
          style={{ padding: '25px 50px', margin: '0 -16px' }}
          spacing={2}
          justifyContent="center"
        >
          <Grid item sm={12}>
            <Typography variant="h4">
              {type == globalPageTypeEntity.edit ? 'Edit' : 'Add'} Product
            </Typography>
          </Grid>
          <Grid item sm={12}>
            <FormControl required variant="outlined" fullWidth>
              <Autocomplete
                name="product"
                disableClearable
                getOptionLabel={(option) => {
                  return option.title == "Policy"?"Policy Management":option.title;
                }}
                disabled={type == globalPageTypeEntity.edit}
                options={productCombination}
                value={selectedProduct}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label=""
                    placeholder="Product"
                  />
                )}
                onChange={(e, payload) => {
                  setSelectedProduct(payload);
                  const defaultValue = Object.keys(
                    payload.addons[1]?.options ?? [],
                  )
                    .filter((key) => payload.addons[1].options[key].default)
                    .pop();
                  if (defaultValue) {
                    setSelectedAddons([
                      payload.addons[1]?.options[defaultValue].value,
                    ]);
                  } else {
                    setSelectedAddons([]);
                  }
                }}
              />
            </FormControl>
          </Grid>
          {selectedProduct?.addons?.length > 0 && (
            <Grid item sm={12}>
              <Grid container style={{ marginLeft: 20 }}>
                <Grid item sm={7}>
                  <Typography> Available Addons</Typography>
                </Grid>
                {Object.keys(selectedProduct?.addons[1].options).map(
                  (addon) => {
                    return (
                      <Grid item sm={7} key={addon}>
                        <FormControlLabel
                          control={
                            selectedProduct?.addons[0].meta.type ==
                            'checkbox' ? (
                              <Checkbox
                                color="primary"
                                onChange={(e) => {
                                  if (
                                    selectedAddons.includes(
                                      e.currentTarget.value,
                                    )
                                  ) {
                                    const index = selectedAddons.indexOf(
                                      e.currentTarget.value,
                                    );
                                    selectedAddons.splice(index, 1);
                                    setSelectedAddons([...selectedAddons]);
                                  } else {
                                    setSelectedAddons([
                                      ...selectedAddons,
                                      e.currentTarget.value,
                                    ]);
                                  }
                                }}
                                value={
                                  selectedProduct?.addons[1]?.options[addon]
                                    ?.value
                                }
                                checked={selectedAddons.includes(
                                  selectedProduct?.addons[1]?.options[addon]
                                    ?.value,
                                )}
                              />
                            ) : (
                              <Radio
                                color="primary"
                                checked={selectedAddons.includes(
                                  selectedProduct?.addons[1]?.options[addon]
                                    ?.value,
                                )}
                                value={
                                  selectedProduct?.addons[1]?.options[addon]
                                    ?.value
                                }
                                onChange={(e) => {
                                  setSelectedAddons([e.target.value]);
                                }}
                              />
                            )
                          }
                          label={
                            selectedProduct?.addons[1]?.options[addon]?.text
                          }
                        />
                      </Grid>
                    );
                  },
                )}
              </Grid>
            </Grid>
          )}
          <Grid sm={8} item>
            <Grid container spacing={2} direction="row">
              <Grid item sm={6}>
                <Button
                  onClick={() => {
                    setOpen(false);
                    setSelectedAddons([]);
                    setSelectedProduct(null);
                  }}
                  variant="contained"
                  color="secondary"
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item sm={6}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={!selectedProduct}
                  onClick={updateProdduct}
                >
                  {false && (
                    <CircularProgress
                      size={20}
                      color="white"
                      style={{ marginRight: '5px' }}
                    />
                  )}
                  {type == globalPageTypeEntity.edit ? 'Update' : 'Save'}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </PopupModal>
    </>
  );
};

export default OrgsProducts;
